import { AdtEventAction } from '~/services/api/enums';

export const EMPTY_VALUE = '-';
export const MODAL_TITLE = 'Hospitalization Details';
export const DATE_TIME_FORMAT = 'dd MMM y HH:mm';

type EventMeta = {
  label: string;
  eventThemeClass: string;
  titleThemeClass: string;
};

export const DEFAULT_EVENT_METADATA: EventMeta = {
  label: 'Event',
  eventThemeClass: 'defaultTheme',
  titleThemeClass: 'titleDefault',
};

export const EVENT_METADATA_BY_ID: Partial<Record<AdtEventAction, EventMeta>> = {
  [AdtEventAction.Unknown]: {
    label: 'Unknown',
    eventThemeClass: 'defaultTheme',
    titleThemeClass: 'titleDefault',
  },
  [AdtEventAction.Register]: {
    label: 'Registered',
    eventThemeClass: 'registration',
    titleThemeClass: 'titleRegistration',
  },
  [AdtEventAction.PreAdmit]: {
    label: 'Pre-Admitted',
    eventThemeClass: 'registration',
    titleThemeClass: 'titleRegistration',
  },
  [AdtEventAction.Admit]: {
    label: 'Admitted',
    eventThemeClass: 'admission',
    titleThemeClass: 'titleAdmission',
  },
  [AdtEventAction.Transfer]: {
    label: 'Transferred',
    eventThemeClass: 'transfer',
    titleThemeClass: 'titleTransfer',
  },
  [AdtEventAction.Discharge]: {
    label: 'Discharged',
    eventThemeClass: 'discharge',
    titleThemeClass: 'titleDischarge',
  },
  [AdtEventAction.CancelAdmit]: {
    label: 'Cancel Admit',
    eventThemeClass: 'cancellation',
    titleThemeClass: 'titleCancellation',
  },
};
